import { LANGUAGES } from '@savgroup-front-common/constants';

export const REVERSIO_WEBSITE_URL = 'https://www.revers.io';

export const ACCEPTED_LANGUAGES = [LANGUAGES.FR, LANGUAGES.EN];

export const HERO_IMAGE_BY_LOCALE: Record<string, string> = {
  [LANGUAGES.EN]: '/images/OnboardingImageEN.svg',
  [LANGUAGES.FR]: '/images/OnboardingImageFR.svg',
};
